import React, { Component } from "react";
import axios from "../../../axios";
import Alert from "react-s-alert";
import qs from "qs";
import Paging from "../../../components/Paging";
import { SCHEDULE_LIST, SCHEDULE_UPDATE_STATUS } from "../endpoints";
import CustomModal from "../CustomModal";
import { NavLink } from "react-router-dom";
import DropdownView from "./DropdownView";
import XLSX from 'xlsx'

class Score extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataSiswa: [],
            dataSiswaNotE: [],
            dataExport   : [],
            dataExportNotE   : [],
            dataExportParent   : [],
            dataExportParentNotE   : [],
            dataParticipant: [],
            exam_cat_id: 0,
            ratarata:0,
            pageCount: 0,
            currentPage: 0,
            isLoading: false,
            isButtonLoading: false,
            isModalShow: false,
            modalShow:false,
            examId:"",
            nama:"",
            participant_id:"",
            kelasNama:"",
            jumNilai:''
        };

        this.toggle = this.toggle.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeStatus = this.handleChangeStatus.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.exportFile = this.exportFile.bind(this);
        this.generateNilai = this.generateNilai.bind(this);

    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    toggleModal(e) {
        this.setState({
            modalShow: !this.state.modalShow,
            examId : e
        });
    }

    handleChange(event) {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        const newState = {
            [name]: value
        }

        this.setState(
            newState
        )
    }

    handleHapusButton(a) {
        this.setState({ isButtonLoading: true });

        const url = '/exam/delete-exam'

        let newState = {
            locale:"id",
            platform:"web",
            user_id:localStorage.SISMART_USER_ID,
            exam_id:a
        };

        axios({
            method: "post",
            url: url,
            data: qs.stringify(newState)
        })

            .then(response => {
                const result = response.data;

                if (result.status) {
                    Alert.success(result.text);
                    this.props.history.replace(
                        "/exam/schedule"
                    );
                } else {
                    if (Array.isArray(result.text)) {
                        result.text.map(item => {
                            Alert.error(item);

                            return true;
                        });
                    } else {
                        Alert.error(result.text);
                    }

                    this.setState({ isButtonLoading: false });
                }
            })

            .catch(error => {
                console.log(error);
                this.setState({ isButtonLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });

        this.setState({ modalShow: false });
        window.location.reload()
    }

    handlePageClick(data) {
        let selected = data.selected; // zero based index

        this.setState({ currentPage: selected }, () => {
            this.loadData();
        });
    }

    handleChangeStatus(exam_id, exam_status) {
        axios
            .post(SCHEDULE_UPDATE_STATUS, qs.stringify({ exam_id, exam_status }))
            .then(response => {
                this.loadData();
            })
            .catch(error => {
                console.log(error);
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadDataUjian() {
        this.setState({ isLoading: true });

        const params = qs.stringify({
            page: this.state.currentPage + 1,
            locale:"id",
            platform:"web",
            exam_id:this.props.match.params.exam_id
        });

        axios({
            method: "post",
            url: "ujian/" + this.props.match.params.exam_id + "?" + params
        })

            .then(response => {
                const result = response.data;
                if (result.success) {
                    this.setState({
                        tanggal_ujian : result.data.exam_start_date,
                        waktu_ujian : result.data.exam_time_limit,
                        guru : result.data.user_nama,
                        mapel : result.data.mapel_nama,
                        ujianNama : result.data.exam_title,
                        isLoading: false
                    });
                } else {
                    Alert.error(result.message,{
                        position: 'bottom-right',
                    });
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadDataNilai() {
        this.setState({ isLoading: true });

        const params = qs.stringify({
            page: this.state.currentPage + 1,
            locale:"id",
            platform:"web",
            exam_id:this.props.match.params.exam_id,
            cari: this.state.nama,
            participant_id:this.state.participant_id
        });

        axios({
            method: "post",
            url: "ujian/siswanilai?" + params
        })

            .then(response => {
                const result = response.data;
                if (result.success) {
                    let ratarata=0;

                    if (result.data[0].nilai.length > 0){
                        for(let i=0; i<result.data[0].nilai.length; i++){
                            ratarata = ratarata + result.data[0].nilai[i].en_nilai;
                        }
                    }

                    this.setState({
                        max: result.data[0].nilai[0] ? Math.round(result.data[0].nilai[0].en_tot_nilai) : 0,
                        dataSiswa: result.data[0].nilai,
                        kelasNama: result.data[0].kelas.kelas_nama,
                        rata_rata: Math.round(ratarata / result.data[0].nilai.length),
                        isLoading: false
                    });
                } else {
                    Alert.error(result.message,{
                        position: 'bottom-right',
                    });
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadDataParti(){
        this.setState({ isLoading: true });
        const params = qs.stringify({
            locale:"id",
            platform:"web",
            exam_id:this.props.match.params.exam_id
        });

        axios({
            method: "post",
            url: "exam/participant?" + params
        })
            .then(response => {
                const result = response.data;

                if (result.status === true) {
                    const dataParticipant = result.data.participant.map(item => ({
                        key: item.participant_id,
                        value: item.kelas_nama
                    }));

                    this.setState({
                        dataParticipant,
                        isLoading: false
                    });
                } else {
                    Alert.error(result.text,{
                        position: 'bottom-right',
                    });
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadExport() {
        this.setState({ isButtonLoading: true });

        const params = qs.stringify({
            page: this.state.currentPage + 1,
            locale:"id",
            platform:"web",
            exam_id:this.props.match.params.exam_id,
            participant_id:this.state.participant_id
        });

        axios({
            method: "post",
            url: "ujian/siswanilai?" + params
        })
            .then(response => {
                const result = response.data;

                if (result.success) {

                    this.setState({
                        dataExport: result.data,
                        jumNilai:result.data.length,
                        isButtonLoading: false
                    });
                } else {
                    Alert.error(result.message,{
                        position: 'bottom-right',
                    });
                    this.setState({ isButtonLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isButtonLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    generateNilai() {
        this.setState({ isButtonLoading: true });

        const params = qs.stringify({
            page: this.state.currentPage + 1,
            locale:"id",
            platform:"web",
            exam_id:this.props.match.params.exam_id,
            participant_id:this.state.participant_id
        });

        axios({
            method: "post",
            url: "ujian/nilai?" + params
        })
            .then(response => {
                const result = response.data;

                if (result.success) {
                    this.loadDataNilai();
                    this.loadExport();
                } else {
                    Alert.error(result.message,{
                        position: 'bottom-right',
                    });
                    this.setState({ isButtonLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isButtonLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    exportFile() {
        this.setState({ isButtonLoading: true });
        const wb = XLSX.utils.book_new()

        let presensi = [];
        let ws = [];
        this.state.dataExport.map((item, i) => {
            presensi[i] = [["Guru",item.user_nama]]
            presensi[i].push(["Mata Pelajaran",item.mapel_nama])
            presensi[i].push(["Tanggal Ujian",item.exam_start_date])
            presensi[i].push(["Waktu Ujian (menit)",item.exam_end_date])
            presensi[i].push(["Judul Ujian",item.exam_title])
            presensi[i].push([""])
            presensi[i].push(["No","NAMA", "KELAS", "TOTAL SOAL","TOTAL JAWAB","TOTAL NILAI","NILAI SISWA","STATUS"])

            item.nilai.map((it,o) => {
                presensi[i].push([
                    o+1,
                    it.user_nama,
                    this.state.kelasNama,
                    it.en_tot_soal,
                    it.en_tot_jawab,
                    it.en_tot_nilai,
                    Math.round(it.en_nilai),
                    it.en_tot_jawab > 0 ? 'Finish' : 'Belum Ujian'
                ])
            })


            ws[i] = XLSX.utils.aoa_to_sheet(presensi[i])
            XLSX.utils.book_append_sheet(wb, ws[i], this.state.kelasNama + 'Ujian' + item.exam_id)

        })

        XLSX.writeFile(wb, "Rekap Nilai-"+ this.state.kelasNama+"-"+ this.state.ujianNama +".xlsx")
        this.setState({ isButtonLoading: false });
    }

    componentDidMount() {
        this.loadDataUjian();
        this.loadDataNilai();
        this.loadExport();
        this.loadDataParti();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.participant_id !== this.state.participant_id || prevState.nama !== this.state.nama) {
            this.loadDataNilai()
            this.loadDataUjian()
            this.loadExport()
        }
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-header">
                                Detail Report Nilai
                            </div>
                            {this.state.isButtonLoading ? (
                                <div className="card-block">
                                    <div className="loader"></div>
                                    <b style={{ marginLeft:'30%',marginRight:'auto'  }}>Mohon tunggu, System sedang memproses penilaian...</b>
                                </div>
                            ): (

                                <div className="card-block">
                                    <div className="form-group row">
                                        <label className="col-md-2 form-control-label">Guru</label>
                                        <div className="col-md-10">
                                            {": "}<b>{this.state.guru}</b>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-md-2 form-control-label">Mata pelajaran</label>
                                        <div className="col-md-10">
                                            {": "}<b>{this.state.mapel}</b>{" "}
                                            {
                                                this.state.exam_parent > 0 ? (
                                                    <span className="badge badge-primary">Remedial</span>
                                                ): ""
                                            }
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-md-2 form-control-label">Tanggal ujian</label>
                                        <div className="col-md-10">
                                            {": "}<b>{this.state.tanggal_ujian}</b>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-md-2 form-control-label">Waktu ujian</label>
                                        <div className="col-md-10">
                                            {": "}<b>{this.state.waktu_ujian} menit</b>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-md-2 form-control-label">Rata-rata nilai</label>
                                        <div className="col-md-10">
                                            {": "}<b>{this.state.rata_rata ? this.state.rata_rata+"/"+this.state.max : "Peserta Kosong"}</b>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="card-block">
                                <br/><br/>
                                <div className="col-md-12 form-group row">
                                    <div className="col-md-6">
                                        <DropdownView
                                            handleChange={this.handleChange}
                                            stateName="participant_id"
                                            label="Pilih Kelas Peserta"
                                            disabled={this.props.mode === 'Edit' ? true : false}
                                            items={this.state.dataParticipant}
                                            value={this.state.participant_id}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <input
                                            name="nama"
                                            type="text"
                                            className="form-control"
                                            placeholder="Ketikkan Nama Pengguna..."
                                            value={this.state.nama}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">Data Siswa Ujian
                                <div>
                                    {/*<button

                                        className="btn btn-primary btn-sm float-right"
                                        disabled={this.state.isButtonLoading && "disabled" || this.state.dataExport.length === 0 && "disabled"}
                                        onClick={this.exportFile}>
                                        {this.state.isButtonLoading || this.state.dataExport.length === 0 ? "Menyiapkan file..." : "Export Nilai"}
                                    </button>*/}
                                    {
                                        this.state.participant_id !== '' ? (
                                            <NavLink
                                                to={`${this.props.match.url}/${this.state.participant_id}`}
                                                className="btn btn-primary btn-sm float-right"
                                                target="_blank"
                                            >
                                                <i className="fa fa-file-excel-o"></i> Export Nilai
                                            </NavLink>
                                        ) : <button className="btn btn-primary btn-sm float-right">Mohon Pilih Kelas</button>
                                    }

                                    {" "}
                                    <button
                                        className="btn btn-success btn-sm float-right"
                                        disabled={this.state.isButtonLoading && "disabled" }
                                        onClick={this.generateNilai}>
                                        <i className="fa fa-refresh"></i> {this.state.isButtonLoading  ? "Check Nilai..." : "Refresh Nilai"}
                                    </button>
                                </div>
                            </div>
                            <div className="card-block">
                                {this.state.isLoading ? (
                                    "Memuat Data..."
                                ) : this.state.dataSiswa.length === 0 ? (
                                    "Data Kosong, Mohon Refresh nilai untuk mendapatkan nilai terbaru..."
                                ) : (
                                    <div>
                                        <div className="card" style={{ height:"700px", overflowY:"scroll" }}>
                                            <table className="table table-striped table-bordered animated fadeIn">
                                                <thead>
                                                <tr>
                                                    <th>NAMA SISWA</th>
                                                    <th>KELAS</th>
                                                    <th>TOTAL SOAL</th>
                                                    <th>TOTAL JAWAB</th>
                                                    <th>TOTAL NILAI</th>
                                                    <th>NILAI SISWA</th>
                                                    <th width={100}>STATUS</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.state.dataSiswa.map(items => {
                                                    return (
                                                        <tr key={items.user_id}>
                                                            <td>{items.user_nama}</td>
                                                            <td>{this.state.kelasNama}</td>
                                                            <td>{items.en_tot_soal}</td>
                                                            <td>{items.en_tot_jawab}</td>
                                                            <td>{items.en_tot_nilai}</td>
                                                            <td>{Math.round(items.en_nilai)}</td>
                                                            <td>
                                                                <button
                                                                    type="button"
                                                                    className={`btn btn-sm ${
                                                                        items.en_tot_jawab > 0
                                                                            ? "btn-primary"
                                                                            : "btn-warning"
                                                                    }`}

                                                                >
                                                                    {items.en_tot_jawab > 0 ? 'Finish' : 'Belum Ujian'}
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        );
    }
}

export default Score;



// WEBPACK FOOTER //
// ./src/views/Exam/Report/Score.js